import React, { FC } from 'react';

import Text from 'components/styled/Text';

import { isCountryCzechRepublic } from 'utils/UASHelpers';

import { Company } from 'typing/endpoints';

type Props = Pick<Company, 'name'> & Company['billingAddress'];

const CompanyContact: FC<Props> = ({
	name,
	street,
	descriptiveNumber,
	orientationNumber,
	municipality,
	municipalityForeign,
	zipCode,
	country,
}) => (
	<>
		<Text fontSize="lg" mb={0} fontWeight="bold">
			{name}
		</Text>
		<Text mb={0}>{`${!street ? 'Č.' : street} ${
			descriptiveNumber ? `${descriptiveNumber}/` : ''
		}${orientationNumber}`}</Text>
		{isCountryCzechRepublic(country) ? (
			<>
				<Text my={0}>{`${zipCode}, ${municipality?.name}`}</Text>
			</>
		) : (
			<>
				<Text my={0}>
					{zipCode}
					{municipalityForeign ? `, ${municipalityForeign}` : ''}
				</Text>
			</>
		)}
		<Text mt={0}>{country?.name}</Text>
	</>
);

export default CompanyContact;
